import type { TAuthContext } from '@/features/authentication/components/auth-provider.tsx'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'

interface MyRouterContext {
  auth: TAuthContext
}

const RouterDevtools =
  import.meta.env.DEV
    ? lazy(async () => ({
        default: (await import('@tanstack/router-devtools')).TanStackRouterDevtools,
      }))
    : null

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <Outlet />
      {RouterDevtools ? (
        <Suspense fallback={null}>
          <RouterDevtools />
        </Suspense>
      ) : null}
    </>
  ),
})
